import { CheckCircle, X } from "lucide-react";
import { Link } from "react-router-dom";

const Pricing = () => {
  const pricingPlans = [
    {
      name: "Gratis",
      price: "0",
      description: "Perfecto para comenzar",
      features: [
        "Agenda básica",
        "Hasta 20 pacientes",
        "Historial limitado",
        "Programa de referidos",
      ],
      limitations: ["Sin recordatorios WhatsApp", "Sin reportes financieros"],
      cta: "Comenzar Gratis",
      highlighted: false,
      link: "/registrarse",
    },
    {
      name: "Premium",
      price: "4,000,000",
      priceNote: "Gs/año",
      description: "Para profesionales serios",
      features: [
        "🎁 1 mes gratis de prueba",
        "Agenda ilimitada + recordatorios",
        "Pacientes ilimitados",
        "Control financiero completo",
        "6 meses cashback",
        "Soporte prioritario",
        "Actualizaciones automáticas",
      ],
      cta: "Probar 30 días gratis",
      highlighted: true,
      whatsapp: true,
    },
    {
      name: "Estudiante",
      price: "2,000,000",
      priceNote: "Gs/año",
      description: "Precio especial con carnet",
      features: [
        "Todo de Premium",
        "6 meses cashback",
        "Descuento estudiantil 50%",
        "Soporte dedicado",
      ],
      cta: "Solicitar Acceso",
      highlighted: false,
      whatsapp: true,
    },
  ];
  return (
    <section
      id="pricing"
      className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-slate-50 to-blue-50/30"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Elige tu plan perfecto
          </h2>
          <p className="text-xl text-slate-600">
            Sin contratos. Cancela cuando quieras.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {pricingPlans.map((plan, idx) => (
            <div
              key={idx}
              className={`relative rounded-2xl p-8 ${
                plan.highlighted
                  ? "bg-gradient-to-br from-blue-600 to-blue-700 text-white shadow-2xl scale-105 border-4 border-blue-400"
                  : "bg-white text-slate-900 border-2 border-slate-200"
              }`}
            >
              {plan.highlighted && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-1 bg-yellow-400 text-slate-900 rounded-full text-sm font-bold">
                  MÁS POPULAR
                </div>
              )}

              <h3
                className={`text-2xl font-bold mb-2 ${
                  plan.highlighted ? "text-white" : "text-slate-900"
                }`}
              >
                {plan.name}
              </h3>
              <p
                className={`text-sm mb-6 ${
                  plan.highlighted ? "text-blue-100" : "text-slate-600"
                }`}
              >
                {plan.description}
              </p>

              <div className="mb-6">
                <div className="flex items-baseline gap-2">
                  <span className="text-5xl font-bold">
                    {plan.price === "0" ? "Gratis" : plan.price}
                  </span>
                  {plan.priceNote && (
                    <span
                      className={`text-sm ${
                        plan.highlighted ? "text-blue-200" : "text-slate-500"
                      }`}
                    >
                      {plan.priceNote}
                    </span>
                  )}
                </div>
              </div>

              <div className="space-y-3 mb-8">
                {plan.features.map((feature, i) => (
                  <div key={i} className="flex items-start gap-2">
                    <CheckCircle
                      className={`w-5 h-5 flex-shrink-0 mt-0.5 ${
                        plan.highlighted ? "text-blue-200" : "text-emerald-500"
                      }`}
                    />
                    <span
                      className={`text-sm ${
                        plan.highlighted ? "text-blue-50" : "text-slate-700"
                      }`}
                    >
                      {feature}
                    </span>
                  </div>
                ))}
                {plan.limitations?.map((limitation, i) => (
                  <div key={i} className="flex items-start gap-2 opacity-60">
                    <X className="w-5 h-5 flex-shrink-0 mt-0.5 text-red-400" />
                    <span className="text-sm text-slate-600">{limitation}</span>
                  </div>
                ))}
              </div>

              {plan.whatsapp ? (
                <button
                  onClick={() =>
                    window.open(
                      `https://wa.me/4917670568851?text=Hola, me gustaría saber más sobre ${plan.name}`,
                      "_blank"
                    )
                  }
                  className={`w-full py-4 rounded-xl font-semibold transition-all ${
                    plan.highlighted
                      ? "bg-white text-blue-600 hover:bg-blue-50 shadow-lg"
                      : "bg-slate-900 text-white hover:bg-slate-800"
                  }`}
                >
                  {plan.cta}
                </button>
              ) : (
                <Link
                  to={`${plan.link}`}
                  className="mx-auto lg:mx-0 hover:underline gradient text-black font-bold rounded-full my-6 py-4 px-8 shadow-lg focus:outline-none focus:shadow-outline transform transition hover:scale-105 duration-300 ease-in-out"
                >
                  {plan.cta}
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
